<div>
  @if (playerProfile?.pictureInactive) {
    <p-avatar
      class="blur-img cursor-pointer clickable"

      [icon]="'pi pi-ban'"
      [size]="size"
      [shape]="shape"
      (click)="onClickInavtive($event)"/>
  } @else if (imageUrl) {
    <p-avatar
      [class.cursor-pointer]="clickable"
      [class.clickable]="clickable"
      [image]="imageUrl"
      [size]="size"
      [shape]="shape"
      (click)="onClick.emit($event)"
      (onImageError)="onImageError($event)"/>
  } @else {
    <p-avatar
      [class.cursor-pointer]="clickable"
      [class.clickable]="clickable"
      [label]="initials"
      [icon]="loginIcon ? 'pi pi-sign-in' : 'pi pi-user'"
      [size]="size"
      [shape]="shape"
      (click)="onClick.emit($event)"/>
  }
</div>
